import React, { Fragment, useEffect, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import "./Roles.css";
import CustomPagination from '../../../components/Pagination/CustomPagination';
import { getRoles, updateRole } from '../../../api/User';
import Loader from '../../../components/Loader/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { decryptData } from '../../../utils/helper';
import { userActions } from '../../../context/reducers/user';
import { failed, success } from '../../../utils/Tostify';
import moment from 'moment';
import EditRole from './EditRole';
import { useConfirmDialog } from '../../../hooks/useConfirmDialog';

function RolesListing({ direction, setCurrentTab, roleData, searchKey, ...args }) {
  let token = useSelector(state => state.userReducer.token);
  let roles = useSelector(state => state.userReducer.rolesListing);
  const { getConfirmation } = useConfirmDialog();
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [RoleData, setRoleData] = useState({});
  const [dropdownTwoOpen, setDropdownTwoOpen] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" }); // Sorting state

  const toggletwo = (id) => {
    setDropdownTwoOpen(prevState => prevState.includes(id) ? prevState.filter(item => item !== id) : [...prevState, id]);
};

  const getRoleList = async(page, limit, searchKey = "")=>{
    let res;
    try {
        setIsLoading(true);
        res = await getRoles({ dispatch, token, page, limit, searchKey });
        const responseData = decryptData(res?.data);
        if (res?.status === "SUCCESS") {
            dispatch(userActions.rolesListing(responseData));
            setIsLoading(false);
        }else{
          setIsLoading(false);
        }
    } catch (error) {
        failed(res?.message);
        setIsLoading(false);
    }
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
        direction = "desc";
    }
    setSortConfig({ key, direction });
};

const sortData = (data) => {
    if (!sortConfig.key) return data;
    return [...data].sort((a, b) => {
        let aValue = a[sortConfig.key]?.toLowerCase();
        let bValue = b[sortConfig.key]?.toLowerCase();
        if (aValue < bValue) {
            return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (aValue > bValue) {
            return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
    });
};

const filteredAndSortedData = sortData(roles?.items);


  const handlePagination = (page) => {
    getRoleList(page, 10, searchKey);
  };

  const handleToggle = async(e, roleId, roleName)=>{
    let msg = e.target.checked === true ? "Activate" : "Deactivate";
    const isChecked = e.target.checked;
    // Temporarily prevent checkbox from updating by setting it back to its previous state
    e.target.checked = !isChecked;
    const confirmed = await getConfirmation({
        title: "Attention!",
        entryName: "",
        actionBtnTitle: "Yes",
        message : `Are you sure want to ${msg} role ${roleName}`
    });
    if(confirmed){
      let values = {active : isChecked, roleId: roleId};
      let res;
      try {
          setIsLoading(true);
          res = await updateRole({values, dispatch, token });
          if (res?.status == "SUCCESS") {
              await getRoleList(roles?.currentPage, 10);
              setIsLoading(false);
              success(res?.message);
          }else{
            setIsLoading(false);
            failed(res?.message);
          }
      } catch (error) {
          setIsLoading(false);
          failed(res?.message);
      }
    }else{
            return true;
      }
  };

  useEffect(() => {
    let timerOut = setTimeout(async () => {
      getRoleList(1, 10, searchKey);
    }, 1000);
    return () => clearTimeout(timerOut);
  }, [searchKey]);
  return (
    <Fragment>
      {isLoading && <Loader/>}
      {showModal && <EditRole refetch={()=> getRoleList()} roleData={RoleData} setShowModal={() => setShowModal(!showModal)}/>}
      <div className="table_space roles_container table_listing_color">
        <div className="forms_block_workflow">
          <div className="table-wrapper">
            <table className='scroll-table-four'>
              <thead>
                <tr className="header_table">
                  <th onClick={() => handleSort("roleName")}>Role Name <i className='fas fa-sort'></i></th>
                  {/* <th></th> */}
                  <th onClick={() => handleSort("portalLayout")}>Portal Layout   <i className='fas fa-sort'></i></th>
                  <th>Active</th>
                  <th onClick={() => handleSort("createdAt")}>Created Date <i className='fas fa-sort'></i></th>
                  <th onClick={() => handleSort("updatedAt")}>Update Date <i className='fas fa-sort'></i></th>
                  <th></th>
                </tr>
              </thead>
              <tbody  className='scrollable-tbody-four'>
              {filteredAndSortedData?.length > 0 && filteredAndSortedData?.map((role,index)=> (
              <Fragment key={role?._id}>
                <tr>
                  <td colSpan={8} className="bg_light"></td>
                </tr>
                <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                  <td className='text-truncate'><div>{role?.roleName}</div>
                  <div className='user_table_blk'><i className="fa fa-user"></i>{role?.usersWithRole?.length ? role?.usersWithRole?.length : 0 }</div></td>
                  <td>{role?.portalLayout}</td>
                  <td>
                    <div className="toggle">
                      <input type="checkbox" id={`checktoggle-${role._id}`} checked={role?.active} onChange={(e)=> handleToggle(e, role?._id, role?.roleName)}/>
                      <label htmlFor={`checktoggle-${role._id}`}></label>
                    </div>
                  </td>
                  <td>{moment(role?.createdAt).format("MMM-DD-YYYY")}</td>
                  <td>{moment(role?.updatedAt).format("MMM-DD-YYYY")}</td>
                  <td>
                    <Dropdown isOpen={dropdownTwoOpen.includes(role?._id)} toggle={() => toggletwo(role?._id)} direction={direction}>
                      <DropdownToggle className="pro_text d-flex" caret>
                        <div className="for_details">
                          <i className="fa fa-ellipsis-v"></i>
                        </div>
                      </DropdownToggle>
                      <DropdownMenu {...args}>
                        {role?.active ? <DropdownItem onClick={()=> {setShowModal(true); setRoleData(role);}}>Edit</DropdownItem> : null}
                        <DropdownItem onClick={()=> {setCurrentTab("rolesDetails"); roleData(role);}}>View Details</DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </td>
                </tr>
                </Fragment>
              ))}
              </tbody>
            </table>
          </div>
          <CustomPagination
            tableData={roles?.items}
            totalPages={roles?.totalPages}
            totalRows={roles?.totalItems}
            rowsPerPage={10}
            page={roles?.currentPage}
            handlePage={handlePagination}
        />
        </div>
      </div>
    </Fragment>
  );
}

export default RolesListing;
